import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MessagesSmartComponent } from './messages-smart.component';


const messagesRoutes: Routes = [{ path: '', component: MessagesSmartComponent }];

@NgModule({
  imports: [RouterModule.forChild(messagesRoutes)],
  exports: [RouterModule]
})
export class MessagesRoutingModule { }
